import { render } from "./FadeHeightTransition.vue?vue&type=template&id=13195d14&scoped=true"
import script from "./FadeHeightTransition.vue?vue&type=script&lang=js"
export * from "./FadeHeightTransition.vue?vue&type=script&lang=js"

import "./FadeHeightTransition.vue?vue&type=style&index=0&id=13195d14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13195d14"]])

export default __exports__